module.exports = __webpack_public_path__ + "static/media/logo-vrf.f9d2dfdd.svg";